<ng-form>
  <fieldset>
    <cap-form-row column-classes="col-md-1,col-md-1">
      <cap-form-control column-classes="col-md-2,col-md-2" labelKey="Gemeinde">
        <cap-pol-gemeinde
          (blur)="onTouched()"
          (ngModelChange)="model && (model.polGemeindeId = $event)"
          [hasfocus]="hasfocus"
          [ngModel]="model && model.polGemeindeId"
          [searchMode]="searchMode"
          class="typeahead-holder"
          name="geometerGeschaeft.polGemeindeId"></cap-pol-gemeinde>
        <button (click)="emptyGemeindeSearch()" class="btn btn-white" tabindex="-1" type="button">
          <span class="fas fa-times"></span>
        </button>
      </cap-form-control>
      <cap-form-control invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="Jahr">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.jahr = $event)"
          [ngModel]="model && model.jahr"
          name="geometerGeschaeft.jahr"
          size="10"
          type="text" />
      </cap-form-control>
      <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Nummer">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.nummer = $event)"
          [ngModel]="model && model.nummer"
          name="geometerGeschaeft.nummer"
          size="10"
          type="text" />
      </cap-form-control>
      <cap-form-control invalidKey="EingabeMussValideNummerSein" labelKey="Index">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.index = $event)"
          [ngModel]="model && model.index"
          name="geometerGeschaeft.index"
          size="10"
          type="text" />
      </cap-form-control>
    </cap-form-row>
  </fieldset>
</ng-form>
